<template>
  <div class="d-flex justify-content-start ms-2">
    <div
      v-for="(image, index) in images"
      :key="index"
      class="imageWrapper me-1 mt-2 mb-2"
      :style="{ 'background-image': `url(${image})` }"
      style="width: 100px; height: 100px"
    >
      <div class="d-flex justify-content-end">
        <a
          @click="removeImage(index)"
          class="btn btn-icon btn-circle btn-danger"
        >
          <i class="fa fa-times"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageBar",
  props: ["images", "removeImage"],
};
</script>
